import React, { ReactNode } from 'react';
import './TabStyle.scss';

type Props = {
  title: string;
  children: ReactNode;
};

const Tab: React.FC<Props> = (props) => {
  return <div className="tabs-content">{props.children}</div>;
};

Tab.displayName = 'Tab';

export default Tab;
